// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentionList__container-c4d436 {
  max-height: 162px;
  background-color: var(--base-0);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1px;
  border-top: 1px solid var(--base-20);
  display: flex;
  flex-direction: column;
}

.MentionList__load-more-b430bf {
  position: relative;
  top: -10px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/MentionList/styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  max-height: 162px;\n  background-color: var(--base-0);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 1px;\n  border-top: 1px solid var(--base-20);\n  display: flex;\n  flex-direction: column;\n}\n\n.load-more {\n  position: relative;\n  top: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MentionList__container-c4d436`,
	"load-more": `MentionList__load-more-b430bf`,
	"loadMore": `MentionList__load-more-b430bf`
};
module.exports = ___CSS_LOADER_EXPORT___;
